export const vi = {
  title: 'Thông báo',
  description: 'Thông báo từ các phân hệ của Portal.',
  all: 'Tất cả',
  unread: 'Chưa đọc',
  preferences: 'Tuỳ chọn',
  markAllRead: 'Đánh dấu tất cả đã đọc',
  markRead: 'Đánh dấu đã đọc',
  viewAll: 'Xem tất cả',
  loadMore: 'Xem thêm',
  empty: 'Chưa có thông báo',
  emptyUnread: 'Không có thông báo chưa đọc',
  loadError: 'Không tải được thông báo',
  retry: 'Thử lại',
  open: 'Mở',
  unreadCount_one: '{{count}} chưa đọc',
  unreadCount_other: '{{count}} chưa đọc',
  prefs: {
    description:
      'Chọn nhận từng loại thông báo trong Portal và/hoặc qua email. Loại bắt buộc không tắt được.',
    type: 'Loại thông báo',
    in_app: 'Trong Portal',
    email: 'Email',
    mandatory: 'Bắt buộc',
    empty: 'Chưa có loại thông báo nào',
    saved: 'Đã lưu tuỳ chọn',
  },
  errors: {
    'core-notification': {},
    generic: 'Thao tác không thành công. Vui lòng thử lại.',
  },
};

export const en: typeof vi = {
  title: 'Notifications',
  description: 'Notifications from the Portal’s modules.',
  all: 'All',
  unread: 'Unread',
  preferences: 'Preferences',
  markAllRead: 'Mark all as read',
  markRead: 'Mark as read',
  viewAll: 'View all',
  loadMore: 'Load more',
  empty: 'No notifications yet',
  emptyUnread: 'No unread notifications',
  loadError: 'Could not load notifications',
  retry: 'Retry',
  open: 'Open',
  unreadCount_one: '{{count}} unread',
  unreadCount_other: '{{count}} unread',
  prefs: {
    description:
      'Choose to receive each kind of notification in the Portal and/or by e-mail. Mandatory ones cannot be turned off.',
    type: 'Notification',
    in_app: 'In Portal',
    email: 'E-mail',
    mandatory: 'Mandatory',
    empty: 'No notification types yet',
    saved: 'Preferences saved',
  },
  errors: {
    'core-notification': {},
    generic: 'The action failed. Please try again.',
  },
};
